import { lowerMenuItems, menuItems } from '@lib/constants/sidemenu/neo-sidemenu.constants';
import { Theme } from '../theme.interface';
import { NeoHomeComponent } from '@pages/home/components/neo-home/neo-home.component';
import { SendMoneyComponent } from '@pages/send-money/tenant7/send-money.component';

export const neoConfig: Theme = {
    name: 'neoConfig',
    properties: {
        '--font-family': 'Readex Pro',
        '--primary-color': '#4656AD',
        '--primary-color-light': '#4656AD',
        '--border-radius': '6.25rem',
        '--heading-font-size': '3rem',
    },
    assets: {
        clientName: 'INC',
        otpFieldStyle: 'input-otp-underlined',
        loginSvg: 'assets/neo/login.svg',
        logoSvg: 'assets/neo/logo.svg',
        sideMenu: menuItems,
        // sideMenuSecondaryItems: lowerMenuItems,
        loginFlow: 'passcode',
        homeComponent: NeoHomeComponent,
        loginLayoutColumnLeft: 'col-lg-4',
        loginLayoutColumnRight: 'col-lg-8',
        sendMoneyComponent: SendMoneyComponent,
        allowedCountriesInPhoneSearch: ['iq'],
        favicon: 'assets/neo/favicon.ico',
    },
};
